// extracted by mini-css-extract-plugin
export var aircallIframe = "_cs-3";
export var fabContainer = "_cs-5";
export var fabRinging = "_cs-6";
export var loadingOverlay = "_cs-4";
export var pulse = "_cs-7";
export var widgetContent = "_cs-2";
export var widgetPanel = "_cs-0";
export var widgetPanelExpanded = "_cs-1";